<template>
	<apexchart
		:width="width"
		:height="height"
		:options="options"
		:series="parsedData"
	/>
</template>
  
<script>
import VueApexCharts from "vue-apexcharts";

export default {
	name: "SatisfactionChart",
	props: {
		title: {
			type: String,
			default: "Pesquisa de Satisfação"
		},
		width: {
			type: [Number, String],
			default: "100%",
		},
		height: {
			type: [Number, String],
			default: "100%",
		},
		loading: {
			type: Boolean,
		},
		data: {
			type: Object,
			default: () => ({})
		}
	},
	components: {
		apexchart: VueApexCharts,
	},
	data: function () {
		return {};
	},
	computed: {
		parsedData(){
			if(!this.data) return [];
			if(Object.keys(this.data).length){
				return Object.values(this.data);
			}
			return []
		},
		options() {
			return {
				chart: {
					type: "donut",
				},
				title: {
					text: this.title,
					align: "center",
					style: {
						fontSize: "14px",
						fontWeight: "bold",
					},
				},
				plotOptions: {
					pie: {
						donut: {
							labels: {
								show: true,
								total: {
									show: true,
									label: "Total",
									fontSize: "14px",
									fontWeight: "bold",
									color: "black",
								},
							},
						},
					},
				},
				dataLabels: {
        		  enabled: true,
        		  style: {
        		    colors: ["#fff"],
        		    fontSize: "11px",
        		    fontWeight: "bold",
        		  },
        		  dropShadow: {
        		    enabled: true,
        		    top: 0,
        		    left: 0,
        		    blur: 1,
        		    opacity: 0.9,
        		    color: "black",
        		  },
        		},
				colors: ["#478e47", "#65ca65", 'goldenrod' , "#d74d4d", "#c31a1a"],
				noData: {
					text: this.loading ? "Loading..." : "No Data",
				},
				labels: Object.keys(this.data || {}),
				legend: {
					position: "right",
					horizontalAlign: "center",
				},
			};
		},
	},
};
</script>

<style lang="scss" scoped>

</style> 
  